import {descend, prop, sortWith} from 'ramda';

import {OperationTypeCount} from '@dms/api/settings';

import {getOperationGroupId} from './getOperationGroupId';

export interface AggregatedOperationType {
  groupId: string;
  // A representative pair from the group, used to resolve the label and icon.
  resource: string;
  action: string;
  count: number;
  previousCount: number;
}

/**
 * Folds tenant-wide operation types into groups (summing count + previousCount
 * for pairs that share a group id), sorted by summed count desc. Drives one
 * card / leaderboard column per group.
 */
export const aggregateOperationTypes = (
  operationTypes: OperationTypeCount[]
): AggregatedOperationType[] => {
  const grouped = operationTypes.reduce<Record<string, AggregatedOperationType>>(
    (accumulator, operationType) => {
      const groupId = getOperationGroupId(operationType);
      const existing = accumulator[groupId];

      accumulator[groupId] = existing
        ? {
            ...existing,
            count: existing.count + operationType.count,
            previousCount: existing.previousCount + operationType.previousCount,
          }
        : {
            groupId,
            resource: operationType.resource,
            action: operationType.action,
            count: operationType.count,
            previousCount: operationType.previousCount,
          };

      return accumulator;
    },
    {}
  );

  return sortWith([descend(prop('count'))], Object.values(grouped));
};
